<div class="product" [class.is-not-allocable]="isNotAllocable()" [class.disabled]="!canMoveProduct()"
  [class.selected]="isSelected" [class.in-basket]="isInBasket"
  [class.placeholder]="placeholder && selectedProductsInBasket === 0">

  <div class="status" [ngClass]="getSapcodeClass()">
    <ng-container *ngIf="!placeholder">
      {{getStatus()}}
      <span *ngIf="product.isBfsHidden" class="bfs-hidden">-&nbsp;<b>HIDDEN</b></span>
    </ng-container>

    <div *ngIf="canRemoveProduct()" class="btn-delete" (click)="handleRemoveProducts.emit([product.sapCode])">
      <img *ngIf="traysService.isBasketAllocation(allocationType)" class="redo-icon"
        src="../../../assets/images/redo.svg" alt="delete_icon">
      <img *ngIf="!traysService.isBasketAllocation(allocationType)" src="../../../assets/images/mini_delete_icon.svg"
        alt="delete_icon">
    </div>

    <div *ngIf="isBackup()" class="backup-badge">
      BACKUP
    </div>

  </div>

  <div class="preview" [class.opened-controls]="showControls" (click)="handleClick()"
    [class.active-placeholder]="placeholder && selectedProductsInBasket>0">
    <app-image-wrapper *ngIf="!placeholder" [media]="product.media" [defaultTheme]="false">
    </app-image-wrapper>
    <app-image-wrapper *ngIf="placeholder" [media]="'../../../assets/images/add_product_icon.svg'"
      [defaultTheme]="false">
    </app-image-wrapper>
  </div>

  <div class="sapcode" *ngIf="!placeholder">
    <span class="copy" (click)="copySapCode()" [matTooltipDisabled]="false"
      [matTooltip]="'SWAP_AREA.COPY_SAPCODE' | translate" [matTooltipClass]="'copy-tooltip'">
      {{product.sapCode}}
      <div *ngIf="product.isRepetitive && product.bookedForSale" class="star">
        <img src="../../../assets/images/placeholder_star.svg" alt="star">
      </div>
    </span>

    <div class="allocations" *ngIf="!placeholder && product.allocations">
      {{product.allocations}}
    </div>
    <div class="allocations" *ngIf="!placeholder && product.tray">
      {{product.tray}}
    </div>

    <div *ngIf="isInExtraTrays()" class="btn-info" [matTooltip]="getExtraTrays() || ''"
      [matTooltipClass]="'extratray-tooltip'">
      <img src="../../../assets/images/info.svg" alt="info_icon">
    </div>
  </div>

  <ng-container *ngIf="placeholder">
    <div class="placeholder" *ngIf="selectedProductsInBasket > 0">
      {{ 'SWAP_AREA.PRODUCTS.PLACEHOLDER' | translate:{products: selectedProductsInBasket} }}
    </div>
    <div class="placeholder" *ngIf="selectedProductsInBasket === 0">
      {{ 'SWAP_AREA.PRODUCTS.EMPTY_PLACEHOLDER' | translate }}
    </div>
  </ng-container>

  <!-- Controlli per l'ordinamento nelle vetrine -->
  <div *ngIf="disabled && !placeholder" class="controls" [class.hidden]="!showControls">
    <button [disabled]="disabled.left" (click)="handleShift.emit(-1)">
      <img src="./assets/images/long-arrow-left.svg" alt="left">
      left
    </button>
    <button [disabled]="disabled.right" (click)="handleShift.emit(1)">
      <img src="./assets/images/long-arrow-right.svg" alt="right">
      right
    </button>
  </div>

</div>
